import { useState, useEffect } from "react";
import FormFloorImage from "../_FormFloorImage";
import FormTablesGroup from "../_FormTablesGroup";
import FormTable from "../_FormTable";
import EventFormRequest from "../EventFormRequest";
import { useParams } from "react-router-dom";
import ModalConfirmation from "../../../../Layout/Modals/ModalConfirmation";
import { toast } from "react-toastify";
import '../_FormTable.css'; // Ensure we have common styles if needed, though mostly using template classes

const TablesList = () => {
    let params = useParams();
    const [state, setState] = useState({
        list: [],
        modalTablesGroupFrom: {
            show: false,
            groupColor: "",
        },
    });

    const [modalFormFloorImage, setModalFormFloorImage] = useState({
        show: false,
        id: 0
    });
    const [modalFormTables, setModalFormTables] = useState({
        show: false,
        id: 0
    });

    const [modalConfirmationState, setModalConfirmationState] = useState({
        isVisible: false,
        param: 0,
        text: ''
    });
    const handleHideModalConfirmation = () =>
        setModalConfirmationState({
            isVisible: false,
            param: 0,
        });

    const getTablesList = async () => {
        const response = await EventFormRequest.getTables(params);
        if (response.status) {
            setState({
                ...state,
                list: response.data
            });
        }
    }

    useEffect(() => {
        getTablesList()
    }, []);

    const handlerModalTablesGroup = (color) => {
        setState({
            ...state,
            modalTablesGroupFrom: {
                show: true,
                groupColor: color,
            },
        });
    };

    const handlerTablesGroupChangePrice = (color, price) => {
        // Implementation for group price change
    };

    const handlerModalTable = (id) => {
        // handlerShowFormTable covers this functionality
    };

    const handlerTableChangePrice = (id, price) => {
        // Implementation for single price change
    };


    const ListTables = () => {

        // GroupColors component omitted as it was commented out in original logic or not fully implemented visually in new design yet.
        // If needed, it can be reintroduced with better styling.

        const Tables = () => {
            if (!state.list || state.list.length === 0) {
                return (
                    <div className="col-12">
                        <div className="d-flex flex-column align-items-center justify-content-center p-5 rounded-4 border border-secondary border-opacity-10" style={{ background: 'rgba(255,255,255,0.02)' }}>
                            <i className="fa-solid fa-couch fs-1 text-muted mb-3 opacity-50"></i>
                            <h4 className="text-white-50">Nenhuma mesa configurada</h4>
                            <p className="text-muted small">Adicione mesas ou importe uma configuração existente.</p>
                        </div>
                    </div>
                );
            }

            return state.list.map((item) => {
                return (
                    <div
                        className="col-12 col-md-4 mb-4"
                        key={item.id}
                        onClick={() => handlerShowFormTable(item.id)}
                        role="button"
                    >
                        <div className="campaign-card glass-glow h-100 p-4 border-0 transition-hover position-relative" style={{ borderLeft: `4px solid ${item.color}` }}>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <h3 className="fs-5 fw-bold text-white mb-0 text-truncate pe-2">{item.name}</h3>
                                <div className="bg-white bg-opacity-10 px-2 py-1 rounded-3 small fw-bold text-white text-nowrap">
                                    {item.base_price}€
                                </div>
                            </div>

                            <div className="d-flex align-items-center text-muted small mb-3">
                                <i className="fa-solid fa-users me-2 text-white-50"></i>
                                <span className="text-white-50">Até {item.limit_numberOfGuests} pessoas</span>
                            </div>

                            {item.description && (
                                <p className="text-muted small mb-0 line-clamp-2" style={{ opacity: 0.7 }}>
                                    {item.description}
                                </p>
                            )}

                            <div className="mt-3 pt-3 border-top border-white border-opacity-10 d-flex justify-content-between align-items-center">
                                <span className="text-primary small fw-bold hover-underline">
                                    Editar <i className="fa-solid fa-pen-to-square ms-1"></i>
                                </span>
                            </div>
                        </div>
                    </div >
                );
            });
        };

        return (
            <div className="row">
                <Tables />
            </div>
        );
    };

    const handlerShowFormTable = (id = 0) => {
        setModalFormTables({
            ...modalFormTables,
            show: true,
            id: id,
        });
    };

    const handlerShowFormFloorImage = () => {
        setModalFormFloorImage({
            ...modalFormFloorImage,
            show: true,
        });
    };



    const handlerConfirmTableImport = () => {
        setModalConfirmationState({
            isVisible: true,
            param: {},
            text: 'Deseja importar as mesas pré-definidas? Isto irá substituir as mesas atuais.'
        });
    };

    const handlerTableImport = async () => {
        handleHideModalConfirmation();
        const response = await EventFormRequest.importTables(params);
        if (response.status) {
            toast.success("Importação concluida com sucesso.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            getTablesList();
        }
    };
    return (
        <>
            <div className="row mb-4 align-items-center">
                <div className="col-md-6">
                    &nbsp;
                </div>
                <div className="col-md-6 d-flex justify-content-md-end gap-2 mt-3 mt-md-0">
                    <button
                        className="btn-action-secondary px-3 py-2 small d-flex align-items-center gap-2 rounded-3"
                        onClick={() => handlerConfirmTableImport()}
                        title="Importar do Nightspot"
                    >
                        <i className="fa-solid fa-cloud-arrow-down"></i>
                        <span className="d-none d-sm-inline">Importar</span>
                    </button>
                    <button
                        className="btn-action-secondary px-3 py-2 small d-flex align-items-center gap-2 rounded-3"
                        onClick={() => handlerShowFormFloorImage()}
                    >
                        <i className="fa-solid fa-map"></i>
                        <span className="d-none d-sm-inline">Planta</span>
                    </button>
                    <button
                        className="btn-action-primary px-4 py-2 small fw-bold shadow-sm d-flex align-items-center gap-2 rounded-3"
                        onClick={() => handlerShowFormTable()}
                    >
                        <i className="fa-solid fa-plus"></i>
                        <span>Nova Mesa</span>
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <ListTables />
                </div>
            </div>
            <ModalConfirmation
                show={modalConfirmationState.isVisible}
                param={modalConfirmationState.param}
                handleModalhide={handleHideModalConfirmation}
                handleModalConfirm={(param) => handlerTableImport(param)}
                text={modalConfirmationState.text}
            />
            <FormTable
                show={modalFormTables.show}
                handleModalhide={() => {
                    getTablesList();
                    setModalFormTables({
                        show: false,
                        id: 0
                    });
                }}
                id={modalFormTables.id}
            />
            <FormFloorImage
                show={modalFormFloorImage.show}
                handleModalShow={() =>
                    setModalFormFloorImage({
                        ...modalFormFloorImage,
                        show: true,
                    })
                }
                handleModalhide={() =>
                    setModalFormFloorImage({
                        ...modalFormFloorImage,
                        show: false,
                    })
                }
                id={modalFormFloorImage.id}
            />
            <FormTablesGroup
                show={state.modalTablesGroupFrom.show}
                handleModalhide={() => {
                    setState({
                        ...state,
                        modalTablesGroupFrom: {
                            show: false,
                        },
                    });
                }}
                color={state.modalTablesGroupFrom.groupColor}
                handlerSubmit={(price) => {
                    handlerTablesGroupChangePrice(
                        state.modalTablesGroupFrom.groupColor,
                        price,
                    );
                }}
            />
        </>
    )
}

export default TablesList;